import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { Add } from '@material-ui/icons'
import { useMutation } from '@apollo/client'
import styles from '../vehicle.module.scss'

import { MC_VEHICLE_VARIATION } from 'graphql/mutations'

const NewVariation = ({ update, loading, makeId }) => {
  const [mkUi, setMkUI] = useState(false)
  const [vvrName, setVvrName] = useState('')
  const [sdmzFile, setSdmzFile] = useState()

  const handleClose = () => {
    setMkUI(false)
  }

  const [call] = useMutation(MC_VEHICLE_VARIATION)

  const submit = () => {
    handleClose()
    loading(true)
    call({
      variables: {
        makeId: parseInt(makeId),
        vvrBdyColor: [],
        vvrIntColor: [],
        sdmzFile,
        vvrName,
      },
    })
      .then(res => {
        update()
      })
      .catch(err => console.log(err))
  }
  return (
    <div>
      <div>
        <Button
          endIcon={<Add />}
          variant="contained"
          fullWidth={false}
          color="primary"
          className={styles.addNewVariationButton}
          onClick={() => setMkUI(true)}
        >
          add new variation{' '}
        </Button>
      </div>
      <Dialog open={mkUi} onClose={() => setMkUI(false)}>
        <DialogTitle>Create new Make</DialogTitle>
        <DialogContent dividers className={styles.newVariationDialogContent}>
          <TextField
            value={vvrName || ''}
            onChange={v => setVvrName(v.target.value)}
            label="varint name"
            variant="outlined"
            className={styles.variantName}
          />
          <Button
            autoFocus
            margin="dense"
            id="model"
            label="Model"
            type="file"
            variant="contained"
            component="label"
          >
            upload Model
            <input
              type="file"
              onChange={e => {
                setSdmzFile(e.target.files.item(0))
              }}
              accept=".sdmz"
            />
          </Button>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => submit()}
              color="primary"
            >
              Submit
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default NewVariation
